import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default function (param) {
  const { data, isRequestSuccessed, exec } = useRequest({
    url: '',
    name: 'PER_SHOTCOUNT_CRAFT',
    manual: false,
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/per/shotcount/craft';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || [], isRequestSuccessed];
}
